import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { currencyOptions, crptoOptionsFlag } from "./currencyOptions";

const TranDetails = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const param2 = queryParams.get("status");
  let param1 = queryParams.get("state");

  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allWithdraws, setAllWithdraws] = useState([]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const token = localStorage.getItem("admintoken");
  // Fetch Transactions
  useEffect(() => {
    const fetchTransactionsData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/transaction/transactions`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          const sortedTransactions = data.transactions.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          setAllTransactions(sortedTransactions);
        } else {
          toast.error(data.message || " No Transactions Found !");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionsData();
  }, []);
  useEffect(() => {
    const fetchWithdrawData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/withdraw/get-withdraws`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          const sortedWithdraws = data.withdrawRequests.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllWithdraws(sortedWithdraws);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawData();
  }, []);
  // Group and sum helper function
  function groupAndSum(transactions, groupByKey, sumKey) {
    return transactions.reduce((acc, transaction) => {
      const key = transaction[groupByKey];
      acc[key] = (acc[key] || 0) + transaction[sumKey];
      return acc;
    }, {});
  }

  // Unified Data Filtering
  let fiatTransactions = [];
  let cryptoTransactions = [];
  let classTransactions = []; // To handle sums by class for pending withdrawals
  let transactionsData = [];
  let availableFiatBalances = [];
  let availableCryptoBalances = [];
  if (param1 === "Withdrawal" && param2 === "Pending") {
    classTransactions = allWithdraws.filter(
      (withdraw) =>
        withdraw.status === "pending" && withdraw.account === "pqsfund"
    );

    cryptoTransactions = allWithdraws.filter(
      (withdraw) =>
        withdraw.status === "pending" && withdraw.account === "wallet"
    );
  } else if (param1 === "Fees") {
    transactionsData = allTransactions.filter(
      (transaction) =>
        transaction.type === "Sales Fee" ||
        transaction.type === "Hedging Fee" ||
        transaction.type === "Management Fee" ||
        transaction.type === "Processing Fee"
    );
    fiatTransactions = transactionsData.filter(
      (transaction) => transaction.paymentMethod === "Fiat"
    );
    cryptoTransactions = transactionsData.filter(
      (transaction) => transaction.paymentMethod === "Crypto"
    );
  } else if (param1 === "Available Balance") {
    const fiatBalances = {};
    const cryptoBalances = {};

    // Process deposits
    allTransactions
      .filter((transaction) => transaction.type === "Deposit")
      .forEach(({ asset, paymentMethod, amount, currency }) => {
        if (paymentMethod === "Fiat") {
          if (!fiatBalances[currency])
            fiatBalances[currency] = { deposits: 0, fees: 0, withdrawals: 0 };
          fiatBalances[currency].deposits += amount;
        } else if (paymentMethod === "Crypto") {
          if (!cryptoBalances[asset])
            cryptoBalances[asset] = { deposits: 0, fees: 0, withdrawals: 0 };
          cryptoBalances[asset].deposits += amount;
        }
      });

    // Process fees
    allTransactions
      .filter((transaction) =>
        [
          "Sales Fee",
          "Hedging Fee",
          "Management Fee",
          "Processing Fee",
        ].includes(transaction.type)
      )
      .forEach(({ asset, paymentMethod, amount, currency }) => {
        if (paymentMethod === "Fiat") {
          if (!fiatBalances[currency])
            fiatBalances[currency] = { deposits: 0, fees: 0, withdrawals: 0 };
          fiatBalances[currency].fees += amount;
        } else if (paymentMethod === "Crypto") {
          if (!cryptoBalances[asset])
            cryptoBalances[asset] = { deposits: 0, fees: 0, withdrawals: 0 };
          cryptoBalances[asset].fees += amount;
        }
      });

    // Process withdrawals
    allTransactions
      .filter((transaction) => transaction.type === "Withdrawal")
      .forEach(({ asset, paymentMethod, amount, currency }) => {
        if (paymentMethod === "Fiat") {
          if (!fiatBalances[currency])
            fiatBalances[currency] = { deposits: 0, fees: 0, withdrawals: 0 };
          fiatBalances[currency].withdrawals += amount;
        } else if (paymentMethod === "Crypto") {
          if (!cryptoBalances[asset])
            cryptoBalances[asset] = { deposits: 0, fees: 0, withdrawals: 0 };
          cryptoBalances[asset].withdrawals += amount;
        }
      });

    // Calculate available balances
    const calculateAvailableBalance = (balances) =>
      Object.entries(balances).map(
        ([asset, { deposits, fees, withdrawals }]) => ({
          asset,
          deposits,
          fees,
          withdrawals,
          availableBalance: deposits - (fees + withdrawals),
        })
      );

    availableFiatBalances = calculateAvailableBalance(fiatBalances);
    availableCryptoBalances = calculateAvailableBalance(cryptoBalances);

    console.log("Fiat Balances:", availableFiatBalances);
    console.log("Crypto Balances:", availableCryptoBalances);
  } else {
    transactionsData = allTransactions.filter(
      (transaction) => transaction.type === param1
    );
    fiatTransactions = transactionsData.filter(
      (transaction) => transaction.paymentMethod === "Fiat"
    );
    cryptoTransactions = transactionsData.filter(
      (transaction) => transaction.paymentMethod === "Crypto"
    );
  }

  let fiatSums = [];
  let cryptoSums = [];
  // Summing data
  if (param1 === "Available Balance") {
    fiatSums = availableFiatBalances.reduce(
      (acc, { asset, availableBalance }) => {
        acc[asset] = availableBalance;
        return acc;
      },
      {}
    );
    cryptoSums = availableCryptoBalances.reduce(
      (acc, { asset, availableBalance }) => {
        acc[asset] = availableBalance;
        return acc;
      },
      {}
    );
  } else {
    fiatSums = groupAndSum(fiatTransactions, "currency", "amount");
    cryptoSums = groupAndSum(cryptoTransactions, "asset", "amount");
  }
  const classSums = groupAndSum(classTransactions, "class", "amount");

  const getCurrencyFlag = (currency) => {
    if (!currency) return null; // Ensure currency is defined
    const currencyData = currencyOptions.find(
      (option) => option.value === currency
    );
    return currencyData ? currencyData.flag : null;
  };

  const getAssetFlag = (asset) => {
    if (!asset) return null; // Ensure asset is defined
    const assetData = crptoOptionsFlag.find((option) => option.value === asset);
    return assetData ? assetData.flag : null;
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="mt-3">
            <h3 className="price-title">
              Total Fiat {param1} {param2 ? param2 : ""}
            </h3>
            <div className="fiat-container">
              {param1 === "Withdrawal" && param2 === "Pending" ? (
                Object.entries(classSums).length > 0 ? (
                  Object.entries(classSums).map(([className, amount]) => (
                    <div key={className} className="price-item">
                      <span className="amount">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(amount)}
                      </span>

                      <span className="currency">
                        {className || "Unknown Class"}
                      </span>
                    </div>
                  ))
                ) : (
                  <p className="price-item">No records found for Class.</p>
                )
              ) : Object.entries(fiatSums).length > 0 ? (
                Object.entries(fiatSums).map(([currency, amount]) => (
                  <div key={currency} className="price-item">
                    {(() => {
                      const assetFlag = getCurrencyFlag(currency);
                      const flag = assetFlag;

                      if (flag) {
                        return (
                          <img
                            src={flag}
                            alt={currency}
                            style={{ width: "30px", marginRight: "5px" }}
                          />
                        );
                      }
                      return null;
                    })()}
                    <span className="amount">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: currency,
                      }).format(amount)}
                    </span>

                    {/* <span className="currency">{currency}</span> */}
                  </div>
                ))
              ) : (
                <p className="price-item">No records found for Fiat.</p>
              )}
            </div>

            <h3 className="price-title">
              Total Crypto {param1} {param2 ? param2 : ""}
            </h3>
            <div className="crypto-container">
              {Object.entries(cryptoSums).length > 0 ? (
                Object.entries(cryptoSums).map(([asset, amount]) => (
                  <div key={asset} className="price-item">
                    {(() => {
                      const assetFlag = getAssetFlag(asset);
                      const flag = assetFlag;

                      if (flag) {
                        return (
                          <img
                            src={flag}
                            alt={asset}
                            style={{ width: "30px", marginRight: "5px" }}
                          />
                        );
                      }
                      return null;
                    })()}
                    <span className="amount">
                      {new Intl.NumberFormat("en-US").format(amount)}
                    </span>
                    <span className="me-1">{asset} </span>
                  </div>
                ))
              ) : (
                <div className="price-item">No records found</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TranDetails;
